<script setup>
const props = defineProps({ blok: Object })

const paddingClasses = computed(() => {
  switch (props.blok.padding) {
    case 'padding-top':
      return 'pt-mobile lg:pt-desktop'
    case 'padding-bottom':
      return 'pb-mobile lg:pb-desktop'
    case 'padding-both':
      return 'py-mobile lg:py-desktop'
    default: 'padding-none'
      return ''
  }
})
</script>

<template>
  <div :class="paddingClasses">
    <div class="relative container">
      <div class="mx-auto max-w-full px-5 py-12 lg:max-w-5xl lg:min-h-[300px] md:max-w-4xl sm:max-w-3xl lg:py-20 md:py-14">
        <div v-if="blok.title" class="relative z-10 mb-4 text-center text-4xl leading-[1.35] font-bold text-white lg:text-6xl lg:leading-[1.35]">
          {{ blok.title }}
        </div>
        <div v-if="blok.description" class="relative z-10 text-center text-2xl leading-[1.7] text-white sm:text-2xl sm:leading-[1.7]">
          {{ blok.description }}
        </div>
        <ul v-if="blok.actions.length" class="mt-9 flex flex-wrap gap-4 gap-y-custom-md p-0 justify-center">
          <li v-for="action in blok.actions" :key="action.uuid" class="mb-0">
            <StoryblokComponent :blok="action" />
          </li>
        </ul>
      </div>
      <FormSubscribe v-if="blok.input" form-class="translate-y-[50%] !mx-4 !max-w-[400px]" input-class="py-5 px-6 sm:!text-[16px]" button-class="px-8 sm:!text-[16px]" />
      <div
        class="bg-hero absolute inset-0 z-[-10] overflow-hidden rounded-2xl"
      >
        <div class="relative inset-x-0 top-0 h-full w-full opacity-60">
          <div class="absolute inset-0 z-[3] h-full w-full bg-primary opacity-40 mix-blend-difference" />
          <div class="absolute inset-0 z-[2] h-full w-full bg-primary opacity-80 mix-blend-screen" />
          <nuxt-img v-if="blok.media.filename" loading="lazy" :alt="blok.media.alt" class="absolute inset-0 z-[1] h-full w-full object-cover object-center" :src="blok.media.filename" />
        </div>
      </div>
      <div class="absolute inset-0 z-[-11] h-full w-full rounded-xl bg-primary" />
    </div>
  </div>
</template>
